import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import { getUserData } from "../slices/userSlice"

const useRefreshData = () => {
  const dispatch = useDispatch()
  const userId = useSelector(state => state.user?.data?.id)
  useEffect(() => {
    // disable for subscriptions
    // let intervalId = null
    // const getUserDataIntervals = () => {
    //   dispatch(getUserData({ id: userId, source: "useRefreshData" }))
    // }
    // if (userId) {
    //   // getUserDataIntervals()
    //   intervalId = setInterval(getUserDataIntervals, 300000)
    //   return () => clearInterval(intervalId)
    // }
  }, [userId])
}
export default useRefreshData
